import { CIcon } from '~/icons/types'

export const ciChevronRight: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d: 'm8.25 4.5 7.5 7.5-7.5 7.5',
      strokeWidth: '3',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
      stroke: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'chevron-right',
  type: 'solid',
  fill: 'none'
}
